import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { SongsPage } from "@/features/domain/components/songs-page";
import { useI18n } from "@/providers/i18n-provider";

function SongsRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Songs`)}
      description={t(msg`Sign in to open your music library.`)}
    >
      <PageContainer maxWidth="3xl">
        <SongsPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const songsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/songs",
  component: SongsRoutePage,
});
